/* eslint-disable no-unused-vars */
import { Button, Grid } from "@mui/material";
import { makeStyles, withStyles } from "@mui/styles";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import PConfirm from "../../components/pos/PConfirm";
import PDialog from "../../components/pos/PDialog";
import PText from "../../components/pos/PText";
import db from "../../db/db";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AsyncSelect from "react-select/async";
import { SyncUtils } from "../../utils/SyncUtils";
import { v4 as uuidv4 } from "uuid";
import { blue, grey } from "@mui/material/colors";

const useStyles = makeStyles({});

const theme = createTheme({});

const ItemButton = withStyles((theme) => ({
  root: {
    width: "100%",
  },
}))(Button);

export default function PricingSelector(props) {
  const { t } = useTranslation();
  const translate = t;

  const content = (
    <ThemeProvider theme={theme}>
      <div
        style={{
          padding: 20,
          width: "300px",
          backgroundColor: grey[400],
        }}
      >
        <Grid container>
          {props.product.productPricingBeanList.map(
            (item) =>
              item && (
                <Grid item xs={12} style={{ padding: 3 }}>
                  <ItemButton
                    style={{
                      backgroundColor: "#ffffcb",
                      fontSize: "0.9rem",
                      padding: "2px",
                      paddingLeft: "5px",
                      height: "70px",
                      textTransform: "none",
                      textAlign: "left",
                    }}
                    onClick={() => {
                      props.onAddProduct(props.product, item);
                      props.closeWindow(false);
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        height: "45px",
                      }}
                    >
                      <Grid container>
                        <Grid item xs={12}>
                          {item.unitType}
                        </Grid>
                        <Grid item xs={12} style={{ color: blue[900] }}>
                          {item.price}
                        </Grid>
                      </Grid>
                    </div>
                  </ItemButton>
                </Grid>
              )
          )}
        </Grid>
      </div>
    </ThemeProvider>
  );

  function onCloseWindow() {
    props.closeWindow(false);
  }

  return (
    <div>
      <PDialog
        content={content}
        title={"Select Item Type"}
        maxWidth={"xs"}
        fullWidth={false}
        open={true}
        onCloseWindow={onCloseWindow}
        custumClose={false}
        hideSave={true}
        borderLess={true}
      ></PDialog>
    </div>
  );
}
